var _rect, _rect2, _path, _circle, _circle2, _circle3, _circle4, _circle5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _path2, _path3, _path4, _path5, _path6, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon14, _circle16, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroTheme2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1091,
    height: 855.44676,
    viewBox: "0 0 1091 855.44676",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "winter_road") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 726.5,
    y: 795.72338,
    width: 363,
    height: 2,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105.53706,
    y: 263.23384,
    width: 772.84085,
    height: 506.86316,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426.28718,792.37361c32.1037-140.3803,35.89624-330.12064-90.41089-506.86316H556.02123c95.38633,74.20851,253.3312,233.16421,318.55661,506.86316Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#d0cde1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.50791,
    cy: 328.28992,
    r: 6.5338,
    fill: "#d0cde1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 720.75579,
    cy: 440.60822,
    r: 2.90391,
    fill: "#d0cde1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.25269,
    cy: 712.32128,
    r: 2.90391,
    fill: "#d0cde1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.88811,
    cy: 330.9193,
    r: 2.90391,
    fill: "#ff6584"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.07711,
    cy: 594.74623,
    r: 2.90391,
    fill: "#ff6584"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "160.305 383.765 158.853 383.765 158.853 382.313 158.127 382.313 158.127 383.765 156.675 383.765 156.675 384.491 158.127 384.491 158.127 385.942 158.853 385.942 158.853 384.491 160.305 384.491 160.305 383.765",
    fill: "#d0cde1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.72 536.469 155.268 536.469 155.268 535.017 154.542 535.017 154.542 536.469 153.09 536.469 153.09 537.195 154.542 537.195 154.542 538.647 155.268 538.647 155.268 537.195 156.72 537.195 156.72 536.469",
    fill: "#d0cde1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "242.751 294.866 241.299 294.866 241.299 293.414 240.573 293.414 240.573 294.866 239.121 294.866 239.121 295.592 240.573 295.592 240.573 297.044 241.299 297.044 241.299 295.592 242.751 295.592 242.751 294.866",
    fill: "#d0cde1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "837.795 674.834 836.343 674.834 836.343 673.383 835.617 673.383 835.617 674.834 834.165 674.834 834.165 675.56 835.617 675.56 835.617 677.012 836.343 677.012 836.343 675.56 837.795 675.56 837.795 674.834",
    fill: "#d0cde1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "823.457 398.82 822.005 398.82 822.005 397.368 821.279 397.368 821.279 398.82 819.827 398.82 819.827 399.546 821.279 399.546 821.279 400.998 822.005 400.998 822.005 399.546 823.457 399.546 823.457 398.82",
    fill: "#d0cde1"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "229.846 418.177 228.394 418.177 228.394 416.725 227.668 416.725 227.668 418.177 226.216 418.177 226.216 418.903 227.668 418.903 227.668 420.355 228.394 420.355 228.394 418.903 229.846 418.903 229.846 418.177",
    fill: "#d0cde1"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "323.763 672.684 322.311 672.684 322.311 671.232 321.585 671.232 321.585 672.684 320.133 672.684 320.133 673.41 321.585 673.41 321.585 674.862 322.311 674.862 322.311 673.41 323.763 673.41 323.763 672.684",
    fill: "#d0cde1"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "792.629 466.21 791.177 466.21 791.177 464.759 790.451 464.759 790.451 466.21 788.999 466.21 788.999 466.936 790.451 466.936 790.451 468.388 791.177 468.388 791.177 466.936 792.629 466.936 792.629 466.21",
    fill: "#d0cde1"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "325.913 499.906 324.462 499.906 324.462 498.454 323.736 498.454 323.736 499.906 322.284 499.906 322.284 500.632 323.736 500.632 323.736 502.084 324.462 502.084 324.462 500.632 325.913 500.632 325.913 499.906",
    fill: "#d0cde1"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "814.137 561.561 812.685 561.561 812.685 560.109 811.959 560.109 811.959 561.561 810.507 561.561 810.507 562.287 811.959 562.287 811.959 563.739 812.685 563.739 812.685 562.287 814.137 562.287 814.137 561.561",
    fill: "#d0cde1"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "816.287 311.356 814.835 311.356 814.835 309.904 814.109 309.904 814.109 311.356 812.658 311.356 812.658 312.082 814.109 312.082 814.109 313.533 814.835 313.533 814.835 312.082 816.287 312.082 816.287 311.356",
    fill: "#d0cde1"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "614.833 302.752 613.381 302.752 613.381 301.301 612.655 301.301 612.655 302.752 611.203 302.752 611.203 303.478 612.655 303.478 612.655 304.93 613.381 304.93 613.381 303.478 614.833 303.478 614.833 302.752",
    fill: "#d0cde1"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.391 481.266 259.939 481.266 259.939 479.814 259.213 479.814 259.213 481.266 257.761 481.266 257.761 481.992 259.213 481.992 259.213 483.444 259.939 483.444 259.939 481.992 261.391 481.992 261.391 481.266",
    fill: "#d0cde1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M629.39,767.7804l76.501-113.76458L629.54648,780.01928l.15964,12.80137q-8.3773.06389-16.59187-.279l3.79428-164.55322-.104-1.26947.14-.24527.36316-15.54929L533.53017,489.28913l83.67872,109.99753.297,3.28664,2.86589-124.32638L548.01049,352.139l72.56732,104.26735-.75744-257.57221.00161-.8573.02463.84312,4.8035,203.00156,65.94863-82.45934L624.866,419.30966l1.43936,111.20706,60.6863-108.53388L626.52842,546.86606l.80124,61.83672,88.25426-151.18639L627.598,630.275Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.00806,686.40172c2.2427,76.79367-42.62747,104.93685-98.93824,106.58137q-1.962.0573-3.90636.07023-3.91708.02986-7.75808-.13046c-50.92746-2.1142-91.23951-29.14763-93.32522-100.56557-2.15845-73.90871,89.57811-169.93874,96.46089-177.04212.00618-.00018.00618-.00018.01227-.00663.26145-.27069.39535-.40611.39535-.40611S266.76554,609.61428,269.00806,686.40172Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#2cb1bc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.01565,781.34492l35.77057-53.19442-35.69741,58.91711.07465,5.98571q-3.91708.02986-7.75808-.13046l1.77414-76.94232-.04861-.59358.06547-.11469.1698-7.27059-39.173-56.87462,39.12676,51.433.13885,1.53677,1.34-58.13293L127.964,586.998l33.93127,48.75367-.35417-120.43646.00075-.40085.01152.39422,2.246,94.92014,30.83648-38.55661-30.73552,46.73376.673,51.99856,28.3759-50.74862-28.27161,58.3933.37465,28.91382,41.26621-70.69223-41.14076,80.779Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M935.3462,220.32915c2.2427,76.79367-42.62747,104.93684-98.93824,106.58136q-1.962.0573-3.90636.07023-3.91709.02986-7.75808-.13045c-50.92746-2.11421-91.23951-29.14763-93.32522-100.56558C729.25985,152.376,820.99641,56.346,827.87919,49.24259c.00618-.00018.00618-.00018.01227-.00662.26145-.2707.39535-.40611.39535-.40611S933.10368,143.5417,935.3462,220.32915Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#2cb1bc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M832.35379,315.27234l35.77057-53.19442L832.427,320.995l.07465,5.98571q-3.91709.02986-7.75808-.13045l1.77414-76.94233-.04861-.59358.06547-.11469.1698-7.27058-39.173-56.87463,39.12676,51.433.13885,1.53677,1.34-58.13293-33.83491-58.966,33.93127,48.75367-.35417-120.43646.00075-.40085.01152.39423,2.246,94.92013L860.974,105.59949l-30.73552,46.73377.673,51.99855,28.3759-50.74862-28.27161,58.3933.37465,28.91382,41.26621-70.69222-41.14076,80.779Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 621.04699,
    cy: 104.33486,
    r: 5.74955,
    fill: "#cfcce0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 380.7157,
    cy: 192.87797,
    r: 5.74955,
    fill: "#cfcce0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1062.70778,
    cy: 375.45791,
    r: 5.74955,
    fill: "#cfcce0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 945.32174,
    cy: 177.92913,
    r: 5.74955,
    fill: "#cfcce0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.83057,
    cy: 104.33486,
    r: 5.74955,
    fill: "#cfcce0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.93469,
    cy: 198.62752,
    r: 5.74955,
    fill: "#cfcce0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 509.50568,
    cy: 111.23433,
    r: 12.64902,
    fill: "#cfcce0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.8234,
    cy: 177.92913,
    r: 12.64902,
    fill: "#cfcce0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 411.76329,
    cy: 57.18853,
    r: 12.64902,
    fill: "#cfcce0"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1010.86664,
    cy: 274.52161,
    r: 12.64902,
    fill: "#cfcce0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.5,793.27662H54.5v-771h1091Zm-1089-2h1087v-767H56.5Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M958.45833,265.22333c-2.9901-.336-5.20257,2.74355-5.03547,5.40656s1.8094,5.05226,2.73614,7.59018c2.03227,5.56545.566,11.60212-.91183,17.30282l-5.06558,19.53977c-1.77114,6.8319-4.18833,14.45412-11.12634,17.83648,6.55.68528,13.39416-2.62126,16.28448-7.86737,1.32032-2.39645,1.97676-5.24467,4.30147-6.94066,2.42838-1.77162,6.04759-1.70321,8.95479-.63634s5.30153,2.96581,7.75793,4.70693c3.40914,2.41643,7.18782,4.6397,11.48865,5.315s9.22722-.53732,11.60107-3.78186c2.154-2.944,2.23119-7.33154,5.73491-8.97093,2.86823-1.342,6.35724.03361,9.1056,1.55945s5.79327,3.30068,8.96715,2.70487c3.80158-.71364,5.82235-4.665,5.46244-8.089s-2.41311-6.49206-4.0609-9.60643a44.46814,44.46814,0,0,1-4.334-29.76331c1.38468-6.67351,4.34118-13.31752,3.22988-20.03094-1.53541-9.27546-11.02112-16.5068-21.39707-18.39928s-21.26756.79625-30.49742,5.398c-5.99066,2.98675-11.63553,6.9515-14.757,12.373s-3.20961,12.5114,1.14933,17.21714",
    transform: "translate(-54.5 -22.27662)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M927.8537,346.11426l-10.78812,18.33981-11.86694,40.27566s-6.11327,12.94575-5.03446,18.33981,0,7.55169,0,17.261-4.67485,13.665,0,21.57625,18.69942,30.926,18.69942,30.926l4.31525,3.23644s5.75366-21.57625,11.86693-23.37427c0,0-6.83248-3.596-3.596-8.27089s6.47288-7.39879,3.596-10.53187-6.47287-1.69467-2.87683-8.88676,3.95565-12.58614,3.95565-13.66495.7192-11.14773,8.27089-10.42852S927.8537,346.11426,927.8537,346.11426Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#d0cde1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.80385,324.538s17.6206,3.23643,22.29545,15.463,19.77823,74.438,19.77823,74.438,4.67485,17.98021,3.23644,23.73388-5.03446,8.9901-2.51723,15.463,7.91129,8.6305,3.95564,15.82258-8.6305,24.45308-20.49743,29.12794-15.463,6.83247-15.463,6.83247l-6.83248-29.12793,4.67486-3.23644s0-7.19208-.35961-8.27089,2.54086-4.4455,4.32706-5.99859,1.42661-13.06043,1.42661-13.06043l-15.82258-53.22141Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#d0cde1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.592,513.68978l-66.88636,32.724,6.11327,124.423s25.17229,92.05865,23.37426,98.53152-25.53189,4.67485-53.2214-2.15762-14.02456-115.79253-14.02456-115.79253S924.97687,513.68978,922.1,499.30561c-2.12883-10.64787,10.522-28.59212,17.2358-37.19027,2.35542-3.01706,3.98084-4.88341,3.98084-4.88341l92.05865-3.95564s.22651,3.63919,6.10607,11.27358c1.51392,1.967,3.40184,4.20017,5.76087,6.70662C1058.7496,483.483,1056.592,513.68978,1056.592,513.68978Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M975.32144,763.97424l5.03446,33.08358-2.51723,34.8816s-19.059,43.15249,15.82258,45.66972,19.059-37.39883,19.059-37.39883a18.95948,18.95948,0,0,0,2.15763-11.14773c-.71921-6.47287-12.22654-67.96517-12.22654-67.96517Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M991.84344,717.92633l3.33795,21.9351-1.669,23.12723s-12.63652,28.611,10.4907,30.28,12.63653-24.7962,12.63653-24.7962a12.57047,12.57047,0,0,0,1.43055-7.39117c-.47685-4.29165-8.10645-45.06233-8.10645-45.06233Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#2f2e41"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "983.033 467.679 1002.092 491.413 965.772 704.299 934.846 699.264 931.25 512.989 983.033 467.679",
    fill: "#2f2e41"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 931.60957,
    cy: 237.89226,
    r: 30.56635,
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M968.12936,280.66632l4.31525,47.10813,38.47764-1.43841s-9.34971-35.60081-4.31525-50.70418Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#a0616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.4814,464.54987c-11.82023,5.11716-36.93852,6.02337-49.798,6.52682-15.39827.60413-42.83964-4.75038-52.34759-8.96135,2.35542-3.01706,3.98084-4.88341,3.98084-4.88341l92.05865-3.95564S1035.60184,456.91548,1041.4814,464.54987Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M953.7452,469.45847s-10.06892,42.43329-9.70931,42.43329,13.30535-7.19208,13.30535-7.19208l1.798-38.47764h-3.95565Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.1191,467.30085c-81.98974-24.09348-120.827,1.07881-121.9058,0s18.33981-33.80279,13.30536-42.07368-14.74377-65.44795-16.54179-76.23607,26.6107-16.54179,26.6107-16.54179l4.33685-2.89123,5.37246-3.58165s63.64993-4.67485,67.60558-7.55168a5.60479,5.60479,0,0,1,3.51333-.61853c6.64908.41355,19.14532,5.83279,23.81658,8.17021,5.75366,2.87684-3.95565,76.59568-3.95565,76.59568s.35961,37.39883,5.03446,52.14259S1050.1191,467.30085,1050.1191,467.30085Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#d0cde1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.09454,323.81881s-5.03446,12.22654-34.8816,19.77822-35.60081-1.798-44.23131-12.58614a17.68389,17.68389,0,0,1-1.05721-1.45281l5.37246-3.58165s63.64993-4.67485,67.60558-7.55168a5.60479,5.60479,0,0,1,3.51333-.61853A36.3676,36.3676,0,0,1,1036.09454,323.81881Z",
    transform: "translate(-54.5 -22.27662)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.67592,306.55781s-1.9384-22.30508-10.85831-7.7363-12.516,16.0072-12.516,16.0072S972.085,296.8485,968.12936,299.00613s-8.9901,9.3497-5.03446,15.82258-14.74376,2.15762-6.11327,12.94574,14.38417,20.13783,44.23131,12.58615,34.8816-19.77823,34.8816-19.77823S1028.54285,304.04058,1016.67592,306.55781Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#d0cde1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M963.59582,213.724a23.26693,23.26693,0,0,0-15.79432,15.553l-.04746.15616c.87865-2.802,1.87484-5.7794,4.18629-7.59066s6.36484-1.66046,7.58541,1.01043a4.47363,4.47363,0,0,1,.35609,2.13348c-.20053,3.2198-3.01311,5.62425-5.808,7.23549s-5.93928,2.95936-7.76339,5.62018c-3.01031,4.3911-1.24013,10.28407-1.23871,15.60795a22.6264,22.6264,0,0,1-8.57506,17.56952l10.14714-4.14834a76.689,76.689,0,0,0-9.37109,27.48092l13.71986-11.33443a60.32806,60.32806,0,0,0-9.01089,26.77995l11.01252-11.284c1.76576,3.04667.00309,6.85419-1.76907,9.89713s-3.60427,6.78843-1.94689,9.89538c9.32083-4.35143,14.06476-15.13128,14.92206-25.382s-1.34436-20.486-1.93372-30.75568c-.28779-5.01489.28388-10.94581,4.56885-13.56706,4.04049-2.47169,9.23612-.68811,13.60569,1.13991l24.74435,10.35186c2.409,1.0078,4.91657,2.087,6.57925,4.10057,3.01579,3.65218,2.28263,9.08275.726,13.556s-3.80825,8.967-3.31822,13.678c.35713,3.4333,2.14388,6.53213,3.94,9.47983s3.68056,5.96062,4.27213,9.36137-.44141,7.33807-3.38534,9.14039a14.50142,14.50142,0,0,0,17.83236-15.04614c-.44055-6.78453-5.57869-12.86409-4.91018-19.63.507-5.13131,4.25822-9.34648,5.706-14.29537a16.87711,16.87711,0,0,0-6.576-18.21966l7.85656,8.358a11.92481,11.92481,0,0,0-.88979-14.40822c-3.36823-3.72081-9.00075-5.1163-11.6139-9.40126-2.6852-4.40312-1.2441-10.38611-3.78331-14.875-6.22041-10.99665-22.1454-3.20133-31.68388-7.03949-3.91979-1.57728-6.89934-3.31315-11.30948-3.18849A44.1911,44.1911,0,0,0,963.59582,213.724Z",
    transform: "translate(-54.5 -22.27662)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroTheme2);
export default __webpack_public_path__ + "static/media/hero-theme2.0c5e3a22f5c08b306a115a028b73eadd.svg";
export { ForwardRef as ReactComponent };